import styled from "styled-components";

export const List = styled.ul`
    max-width: 100%;
    /* Список забирає вільну висоту, але не стискається менше ніж до двох дощок */
    flex: 1 1 auto;
    min-height: 136px;
    &:empty {
        min-height: 0;
    }
overflow-y: auto;
    scrollbar-color: var(--scrollbar-color) var(--scrollbar-background-color);
    scrollbar-width: thin;
`